import { useState, useEffect } from "react";
import { useEvent } from "../../lib/hooks/useEvent.js";
import { debug } from "../../log.js";
import { stub } from "@nbcnews/analytics-framework";
function usePlayerController({ videoHTMLContainer, cvsdk, mvpdId, instanceId }) {
  const [playerController, setPlayerController] = useState(
    /** @type {PlayerController | undefined} */
    void 0
  );
  const trackControllerCreated = useEvent(
    /**
     * @param {object} event
     * @param {PlayerController} event.controller
     * @param {HTMLDivElement} event.videoEl
     */
    ({ controller, videoEl }) => {
      const data = {
        cvsdk,
        PlayerController: controller,
        videoEl,
        omegaInstanceId: instanceId,
        mvpdId
      };
      debug.extend("track:playerInit")(data);
      stub("track", "sigma_cvsdk_playerInit", data);
    }
  );
  useEffect(() => {
    if (!videoHTMLContainer || !cvsdk) {
      return;
    }
    const controller = cvsdk.getPlayerController({
      videoHtmlContainerInfo: { videoHTMLContainer },
      disablePlayoutRect: true
    });
    setPlayerController(controller);
    trackControllerCreated({ controller, videoEl: videoHTMLContainer });
    return () => controller.destroy();
  }, [videoHTMLContainer, cvsdk, trackControllerCreated]);
  return playerController;
}
export {
  usePlayerController };
//# sourceMappingURL=dist/components/CoreVideoPlayer/usePlayerController.js.map